<main>
  <button class="btn-back">Tarifauswahl ändern</button>
  <div class="tarif-card-container">
    <app-tarif-card-selected [plan]="package"></app-tarif-card-selected>
  </div>
  <div [style]="'width: 100%'">
    <button class="btn-pay" (click)="payPackage()">Zahlen</button>
  </div>
</main>